export const DEFAULT_FISCAL_YEAR_START_MONTH = 1;

const MONTHS_PER_YEAR = 12;
const LABEL_PREFIX = 'FY';
const LABEL_DIGITS = 2;
const DATE_PAD_LENGTH = 2;
const DISTINCT_MONTHS_THRESHOLD = 2;

let cachedStartMonth = DEFAULT_FISCAL_YEAR_START_MONTH;

export const setFiscalYearStartMonth = (month) => {
  cachedStartMonth = month;
};

export const getFiscalYearStartMonth = () => cachedStartMonth;

const pad = (value) => String(value).padStart(DATE_PAD_LENGTH, '0');

const formatIsoDay = (year, month, day) => `${year}-${pad(month)}-${pad(day)}`;

const formatDateAsIsoDay = (date) =>
  formatIsoDay(date.getFullYear(), date.getMonth() + 1, date.getDate());

export const fiscalYearLabel = (endYear) =>
  `${LABEL_PREFIX}${String(endYear).slice(-LABEL_DIGITS)}`;

export const getFiscalYearRange = (startMonth, refDate = new Date()) => {
  const refMonth = refDate.getMonth() + 1;
  const startYear = refMonth >= startMonth ? refDate.getFullYear() : refDate.getFullYear() - 1;
  const endDate = new Date(startYear, startMonth - 1 + MONTHS_PER_YEAR, 0);

  return {
    start: formatIsoDay(startYear, startMonth, 1),
    end: formatDateAsIsoDay(endDate),
    label: fiscalYearLabel(endDate.getFullYear()),
  };
};

export const getCurrentFiscalYearToDate = (startMonth, refDate = new Date()) => {
  const { start, label } = getFiscalYearRange(startMonth, refDate);

  return { start, end: formatDateAsIsoDay(refDate), label };
};

export const getPreviousFiscalYear = (startMonth, refDate = new Date()) => {
  const { start } = getFiscalYearRange(startMonth, refDate);
  const [startYear, startMonthIndex] = start.split('-').map(Number);
  const dayBeforeStart = new Date(startYear, startMonthIndex - 1, 0);

  return getFiscalYearRange(startMonth, dayBeforeStart);
};

export const currentFiscalYearToDate = (refDate = new Date()) =>
  getCurrentFiscalYearToDate(cachedStartMonth, refDate);

export const previousFiscalYear = (refDate = new Date()) =>
  getPreviousFiscalYear(cachedStartMonth, refDate);

export const hasDistinctMonthsSinceFiscalYearStart = (refDate = new Date()) => {
  const [startYear, startMonth] = getFiscalYearRange(cachedStartMonth, refDate)
    .start.split('-')
    .map(Number);
  const elapsedMonths =
    (refDate.getFullYear() - startYear) * MONTHS_PER_YEAR + refDate.getMonth() + 1 - startMonth;

  return elapsedMonths >= DISTINCT_MONTHS_THRESHOLD;
};
